module.exports = __webpack_public_path__ + "img/competition.eb5f58ac.svg";